const VueFacebook = {
  install (Vue, options) {
    /* eslint-disable */
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) { return }
      js = d.createElement(s)
      js.id = id
      js.src = '//connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))

    window.fbAsyncInit = function onSDKInit () {
      FB.init(options)
      Vue.prototype.$fB = FB
    }
    /* eslint-enable */
  }
}

export default VueFacebook



// WEBPACK FOOTER //
// ./WebResources/vue/shared/plugins/VueFacebook.js